import React from "react";
import {UnpaidAgentsUIProvider} from "../context/UnpaidAgentsUIContext";
import { UnpaidAgentsLoadingDialog } from "../components/UnpaidAgentsLoadingDialog";
import {UnpaidAgentsCard} from './UnpaidAgentsCard';

export function UnpaidAgentsPage() {

  return (
    <UnpaidAgentsUIProvider>
      <UnpaidAgentsLoadingDialog />
      <UnpaidAgentsCard/>
    </UnpaidAgentsUIProvider>
  );
}
